import { DealerManagementService } from 'src/services/dealer-management.service';
import DealersList from './components/dealersList';
import DistrictList from './components/districtList';
import ImageLogo from '../../../../assets/images/de-full-logo.png';
import { IRoutes } from '../../../../routes';
import { isSiteCanadian } from '../../../../utils/helpers';
import { IUser } from '../../../../utils/interfaces/user';
import MenuLang from './components/menuLang';
import Profile from './components/profile';
import ResponsiveMenu from './components/responsive/responsiveMenu';
import { USER_ACTIONS } from '../../../../utils/enums/user-store-actions.enum';
import { ASSOCIATIONS_NAME, DEFAULTDEALER_NAME } from '../../../../config';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './styles.scss';

interface IArgs {
    routes: Array<IRoutes>;
    permissionsMap: Map<string, Array<string>>;
}

export function useIsDesktop(breakpoint = 1440) {
    const [isDesktop, setIsDesktop] = useState(
        () => window.innerWidth >= breakpoint,
    );

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= breakpoint);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isDesktop;
}

export const TopBar = ({ routes, permissionsMap }: IArgs) => {
    const isDesktop = useIsDesktop();
    const [names, setNames] = useState<
        Array<{ dealerId: string; name: string }>
    >([]);
    const dispatch = useDispatch();
    const permissionsToken = useSelector((state: IUser) => {
        return state.permissionsToken;
    });
    const accessUser = useSelector((state: IUser) => {
        return state.accessUser;
    });
    // Initialize method
    useEffect(() => {
        if (permissionsToken) {
            if (!accessUser) {
                const userAssociations =
                    sessionStorage.getItem(ASSOCIATIONS_NAME);
                const defaultDealer =
                    sessionStorage.getItem(DEFAULTDEALER_NAME);
                if (userAssociations && defaultDealer) {
                    const dealers = JSON.parse(userAssociations);
                    dispatch({
                        type: USER_ACTIONS.SET_DEALERS,
                        payload: {
                            default: defaultDealer,
                            dealers,
                        },
                    });
                    getDealerNamesData(dealers.map((d: any) => d.dealerId));
                }
            }
        }
    }, []);
    async function getDealerNamesData(dealerIds: [string]) {
        const service = new DealerManagementService();
        try {
            const res = await service.getDealerNames(dealerIds);
            if (res && res.data) {
                const namesList = res.data.dealers.map((dealer: any) => {
                    return { dealerId: dealer.dealerId, name: dealer.name };
                });
                setNames(namesList);
            }
        } catch (error) {
            console.error(error);
        }
    }
    const language = isSiteCanadian() ? (
        <li className='c-section-nav__item'>
            <MenuLang />
        </li>
    ) : null;
    return (
        <div
            className='c-section-nav    js-section-nav  js-scroll-observer z-index-1'
            data-scroll-observer-target='body'
            data-scroll-observer-root-margin='0px 0px -100%'
        >
            <div className='c-section-nav__header'>
                {!isDesktop ? (
                    <ResponsiveMenu
                        routes={routes}
                        permissionsMap={permissionsMap}
                        names={names}
                    />
                ) : null}
            </div>

            <nav
                className='c-section-nav__container  js-section-nav__container'
                id='section-nav-container'
                aria-label='Table of contents'
            >
                <div className='c-section-nav__scroll  js-section-nav__scroll c-section-left'>
                    <ul
                        className='c-section-nav__list  js-section-nav__list  js-scroll-observer'
                        data-scroll-observer-target='.js-section-nav__section'
                        data-scroll-observer-root-margin='-49% 0px -50%'
                        data-scroll-observer-track-multiple='true'
                    >
                        <li className='c-section-nav__item'>
                            <a
                                className='brand'
                                href='#my-section-a'
                                data-text='Long title that should break and be truncated (0)'
                            >
                                <img src={ImageLogo} height={15} width={140} />
                            </a>
                        </li>
                    </ul>
                </div>

                {isDesktop ? (
                    <div className='c-section-nav__scroll  js-section-nav__scroll c-section-right'>
                        <ul
                            className='c-section-nav__list  js-section-nav__list  js-scroll-observer'
                            data-scroll-observer-target='.js-section-nav__section'
                            data-scroll-observer-root-margin='-49% 0px -50%'
                            data-scroll-observer-track-multiple='true'
                        >
                            {accessUser ? (
                                <li className='c-section-nav__item'>
                                    <DistrictList />
                                </li>
                            ) : null}
                            <li className='c-section-nav__item'>
                                <DealersList names={names} />
                            </li>
                            {language}
                            <li className='c-section-nav__item'>
                                <Profile />
                            </li>
                        </ul>
                    </div>
                ) : null}
            </nav>
        </div>
    );
};
